"use strict";
import { isPromise } from "../../../src/utils";
import * as loadbigScreen from "./loadbigScreen.mixin";
const customes = {
  loadbigScreen
};

function loadExtends(app, route) {
  let { name, component } = route;
  let temp = {};

  Object.keys(customes).map(key => {
    let extend = customes[key].default;
    if (typeof extend === "function") extend = extend(app, name);

    let { matchRoute, directive, filter, mixin } = extend;
    let flag = false;

    if (!matchRoute || !(directive || filter || mixin)) return;

    if (matchRoute !== "all") {

      if (!Array.isArray(matchRoute)) matchRoute = [matchRoute];
      matchRoute.forEach(route => {
        if (flag) return;
        if (typeof route === "string") {
          if (route === name) flag = true;
        } else if (Object.prototype.toString.call(route) === "[object RegExp]") {
          if (route.test(name)) flag = true;
        }
      });

      if (!flag) return;
    }

    if (/\.directive\.js/.test(key)) {

    }
    else if (/\.filter\.js/.test(key)) {

    }
    else if (/\.mixin\.js/.test(key)) {
      mergerMixin(temp, mixin);
    }
  });

  return () => new Promise(async resolve => {
    let res, com;
    if (typeof component === "function") {
      res = await component();
    } else if (isPromise(component)) {
      res = await component;
    } else {
      res = { default: component };
    }
    com = res.default;

    if (Object.keys(temp).length === 0) resolve(com);
    else {
      com = mergerMixin(com, temp);
      resolve(com);
    }
  });
}

function mergerMixin(component, mixin) {
  if (Array.isArray(component.mixins)) {
    component.mixins.push(mixin);
  } else {
    component.mixins = [mixin];
  }
  return component;
}

// function isPromise(obj) {
//   return !!obj &&
//     (typeof obj === 'object' || typeof obj === 'function') &&
//     ((obj.constructor && obj.constructor.name === 'Promise') || typeof obj.then === 'function')
// }

export default loadExtends;